import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "MaintenanceDashboardPage" */
	'pages/vehicle/Maintenance/MaintenanceDashboardPage'));

export default [{ component, exact: true, path: '/maintenances/:maintenanceId' }];